import { SignalTileChartData } from 'widgets/signalTiles/signalTile/components/chart/signalTileData';
import { useWidgetContext } from 'widgets/WidgetContext';
import React, { useContext } from 'react';
import AppContext from 'app/AppContext';
import { usePointedTime } from 'utils/components/TimeSeriesChart/timepoint';
import { getBucketAtTime } from 'utils/timeseries/bucket';

export interface SignalTileChartValueProps {
    chartData: SignalTileChartData;
}
export function SignalTileChartValue(props: SignalTileChartValueProps) {
    const { widgetKey } = useWidgetContext();
    const { chartData } = props;
    const { numberFormat } = useContext(AppContext);
    const time = usePointedTime('SignalTileChartValue' + widgetKey);

    const bucket = getBucketAtTime(chartData.timeSeries, time);
    const value = numberFormat.n0(bucket?.value);

    return <div className="value">{value}</div>;
}
